import "./index.css";

const PreviousSessionMessage = () => {
  const message =
    "It looks like your last session is still active! To start fresh, please close the previous session first and the start a new one.".split(
      ""
    );

  return (
    <div className="previos-session-message">
      {message.map((char, index) => (
        <span key={index} style={{ "--i": index }}>
          {char === " " ? "\u00A0" : char}
        </span>
      ))}
    </div>
  );
};

export default PreviousSessionMessage;